<!-- prettier-ignore -->

<div 
  class="chat"
  [class.is-custom-route]="checkIsCurrentRouteCustomRoute()"
>
  <div class="chat__form-wrapper">
    <chat-header></chat-header>
  </div>

  <!-- id: destino del skip-link de la página embed (WCAG 2.4.1). -->
  <!-- tabindex="0" + aria-label: región scrollable enfocable y con nombre, operable por teclado (WCAG 2.1.1, axe scrollable-region-focusable). -->
  <!-- role="log" + aria-live="polite": anuncia los mensajes nuevos a lectores de pantalla (WCAG 4.1.3). -->
  <!-- aria-busy durante el streaming (HRS-3045): los lectores anuncian el bloque estable al terminar, no cada lote del texto. -->
  <div class="chat__history" id="chat-history" tabindex="0" role="log" aria-live="polite" [attr.aria-busy]="dataChat.isStreaming()" [attr.aria-label]="'Historial de conversación' | translate" #scrollContainer>
    <chat-bubble />
  </div>

  <div class="chat__form-wrapper">
    <recommended-messages/>

    <div class="opacityEffect opacityEffectEnd"></div>
    <!-- @if(dataChat.chatIsThinking()){
      <div class="chat__form-wrapper__typing_dot_container">  
        <typing-dots class="chat__dots"  /> 
      </div>
    } -->

    <!-- role="status": anuncia la espera a lectores de pantalla (WCAG 4.1.3). La región vive
         FUERA del @if: un aria-live que nace a la vez que su contenido no se anuncia de forma
         fiable. El rotador re-crea nodos en cada frase -> aria-hidden; se anuncia solo el sr-only. -->
    <div role="status">
      @if(dataChat.chatIsThinking() || dataChat.generatingRoute()){
        <div class="chat__form-wrapper__typing_dot_container">
          <span class="sr-only">{{ (dataChat.generatingRoute() ? 'Generando tu ruta' : 'Elaborando respuesta') | translate }}</span>
          <app-blob-loader aria-hidden="true" />
          <text-animation aria-hidden="true" [phrases]="dataChat.generatingRoute() ? dataChat.routeThinkingPhrases : dataChat.thinkingPhrases"/>
        </div>
      }
    </div>
    
    <chat-input-form></chat-input-form>
  </div>
  
</div>
